import React, { Component } from 'react'
import { Row, Col, Icon } from 'react-materialize'
import CountryResourcesCountryTag from './CountryResourcesCountryTag'
import CountryResourcesSelector from './CountryResourcesSelector'
import CountryResourcesTable from './CountryResourcesTable'
import CountryResourcesTableCollapsible from './CountryResourcesTableCollapsible'
import { Combobox } from 'react-input-enhancements'
import { FormControl } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

var $ = require('jquery');

class CountryResources extends Component {
  constructor(props){
    super(props);
    this.state = {
      allData: [],
      allCountries: [],
      countries: [],
      region: {},
      // endpoint: 'https://l8set92mcj.execute-api.us-east-1.amazonaws.com/test/resources', // PROD end point
      endpoint: 'https://kiiihr79w1.execute-api.us-east-1.amazonaws.com/dev/resources' // TEST end point
    }
  }

  componentWillMount(){
    var rthis = this
    $.ajax({
      headers: {
      },
      method: "GET",
      contentType: 'application/json',
      url: this.state.endpoint,
      success: function (data) {
        if (data.errorMessage) {
          alert(data.errorMessage);
        }
        else {
         rthis.setState({ allData: data.result })
         rthis.loadPage(data.result);
        }
      },
      error: function (data){
        alert("Sorry, please try again!")
      }
    })
  }

  loadPage(data){
    var countries = []
    var region = {}
    data.forEach(document => {
      if(region.hasOwnProperty(`${document.region.toUpperCase()} - all`)){
        region[`${document.region.toUpperCase()} - all`].push(document.country)
      } else {
        region[`${document.region.toUpperCase()} - all`] = [document.country]
      }
    })

    for(let country in region){
      region[country] = Array.from(new Set(region[country].sort()))
      countries.push(country)
      countries = countries.concat(region[country])
    }
    this.setState({ region: region, allCountries: countries })
  }

  addCountry(val){
    if(val === 'All Countries'){
      this.setState({ countries: this.state.allCountries.slice() })
    } else if (val.includes('- all')){
      var countries = this.state.countries
      this.setState({ countries: this.state.region[val]})
    } else {
      var countries = this.state.countries
      if(countries.includes(val)){
        alert(`${val} is already selected`)
      } else {
        countries.push(val)
        this.setState({ countries })
      }
    }
  }

  deleteCountry(val){
    var countries = this.state.countries.filter(country => country !== val)
    this.setState({ countries })
  }

  render() {
    const {
      countries,
      allCountries,
      allData
    } = this.state;
    return (
      <div className="OpenCollapsible">
        <Row>
          <Col s={4} className="logo-view">
            <a href="http://www.youthandncds.org/">
              <img alt="logo" src="logo.png" height="43" width="179"/>
            </a>
          </Col>
          <Col s={5} className="" style={{paddingTop: "36px"}}>
            <CountryResourcesSelector
              countries={countries}
              allCountries={allCountries}
              addCountry = {this.addCountry.bind(this)}
              />
          </Col>
        </Row>
        <Row className="header-title" style={{fontFamily: "Roboto, sans-serif"}}>
        Countries Selected
        </Row>
        <Row className="countries-selected">
          {countries.map(country =>
            <CountryResourcesCountryTag
              country={country}
              key={country}
              onDeleteCountry = {this.deleteCountry.bind(this)}
            />
          )}
        </Row>
        <Row>
          <CountryResourcesTableCollapsible allData={allData} countries={countries}/>
          {/* <CountryResourcesTable allData={allData} countries={countries} /> */}
        </Row>
      </div>
    );
  }
}


export default CountryResources;



// WEBPACK FOOTER //
// ./src/components/CountryResources.js